export default "__VITE_ASSET__677c8603__"